import React from 'react';
import { Helmet } from 'react-helmet-async';

const Contact = () => {
  return (
    <div className="container">
      <Helmet>
        <title>Ariel Rotem | Contact & Connect</title>
        <meta name="description" content="Connect with Ariel Rotem. Open a socket for AI research, Google Cloud optimizations, or high-octane photography." />
      </Helmet>
      <div className="mb-4">
        <h1 className="glitch" style={{ color: 'var(--accent-primary)', fontSize: '2.5rem' }}>$ ./ping --target ariel_rotem</h1>
        <p className="mono" style={{ color: 'var(--text-secondary)' }}>
          PING ariel_rotem (Hoboken, NJ): 56 data bytes<br/>
          64 bytes from ariel_rotem: icmp_seq=0 ttl=53 time=14.283 ms
        </p>
      </div>

      <div className="terminal-card" style={{ textAlign: 'center', padding: '40px 20px' }}>
        <h3 className="mb-4" style={{ color: 'var(--accent-secondary)' }}>&gt; INITIATE_HANDSHAKE</h3>
        <p className="mono mb-4 text-primary">
          Interested in AI research, systemic optimizations, or high-octane photography? Open a socket.
        </p>
        <div style={{ display: 'flex', gap: '20px', justifyContent: 'center', flexWrap: 'wrap' }}>
          <a href="mailto:arielrotem@gmail.com" className="btn">mailto:arielrotem@gmail.com</a>
          <a href="https://www.linkedin.com/in/ariel-rotem-5b1b45b2/" target="_blank" rel="noopener noreferrer" className="btn">https://linkedin.com</a>
          <a href="https://github.com/ArielRotem" target="_blank" rel="noopener noreferrer" className="btn">https://github.com</a>
        </div>
      </div>
    </div>
  );
};

export default Contact;
